// extracted by mini-css-extract-plugin
module.exports = {"articles__schema":"_9e1425b4d3--articles__schema--rXIvN","articles-wrap":"_9e1425b4d3--articles-wrap--CIyi7","articles":"_9e1425b4d3--articles--UjWeX"};